// Shared display metadata + helpers for the Task / Workflow engine UI.

export const PRIORITY_META = {
  order_blocking: { label: "Order Blocking", cls: "bg-rose-600 text-white border-rose-600", rank: 0 },
  urgent: { label: "Urgent", cls: "bg-orange-500 text-white border-orange-500", rank: 1 },
  high: { label: "High", cls: "bg-amber-400 text-amber-950 border-amber-400", rank: 2 },
  normal: { label: "Normal", cls: "bg-slate-100 text-slate-600 border-slate-200", rank: 3 },
};

export const STATUS_META = {
  to_do: { label: "To Do", cls: "text-slate-600 border-slate-300" },
  taken: { label: "Taken", cls: "text-sky-700 border-sky-300" },
  in_progress: { label: "In Progress", cls: "text-emerald-700 border-emerald-300 bg-emerald-50" },
  paused: { label: "Paused", cls: "text-amber-700 border-amber-300 bg-amber-50" },
  blocked: { label: "Blocked", cls: "text-rose-700 border-rose-300 bg-rose-50" },
  ready_to_resume: { label: "Ready to Resume", cls: "text-indigo-700 border-indigo-300 bg-indigo-50" },
  partially_completed: { label: "Partially Completed", cls: "text-cyan-700 border-cyan-300 bg-cyan-50" },
  done: { label: "Done", cls: "text-emerald-700 border-emerald-300" },
  cancelled: { label: "Cancelled", cls: "text-slate-400 border-slate-200 line-through" },
  available: { label: "Available", cls: "text-sky-700 border-sky-300" },
  claimed: { label: "Claimed", cls: "text-sky-700 border-sky-300" },
};

export const LINE_STATUS_META = STATUS_META;

export const PAUSE_REASONS = [
  { value: "order_packing", label: "Order Packing" },
  { value: "instant_delivery", label: "Instant Delivery" },
  { value: "break", label: "Break" },
  { value: "higher_priority", label: "Higher Priority Task" },
  { value: "end_of_shift", label: "End of Shift" },
  { value: "other", label: "Other" },
];

export const BLOCK_REASONS = [
  { value: "packaging_material_shortage", label: "Packaging Material Shortage" },
  { value: "special_packing_issue", label: "Special Packing Issue / Unclear Method" },
  { value: "wrong_item_received", label: "Wrong Item Received" },
  { value: "physical_stock_variance", label: "Physical Stock Variance (needs verification)" },
  { value: "item_condition_uncertain", label: "Item Condition Uncertain" },
  { value: "missing_packaging_component", label: "Missing Required Packaging / Accessory / Component" },
  { value: "other", label: "Other (explanation required)" },
];

export const ISSUE_CATEGORIES = [
  { value: "stock_not_available", label: "Stock Not Available" },
  { value: "incomplete_work", label: "Incomplete Work" },
  { value: "wrong_item_picked", label: "Wrong Item Picked" },
  { value: "order_not_located", label: "Order Cannot Be Located" },
  { value: "packing_material_problem", label: "Packing Material Problem" },
  { value: "marketplace_label_problem", label: "Marketplace / Label Problem" },
  { value: "damaged_item", label: "Damaged Item" },
  { value: "other", label: "Other" },
];

export const LOCATION_TYPES = [
  { value: "picking_rack", label: "Picking Rack" },
  { value: "balance_stock", label: "Balance Stock" },
  { value: "handover_area", label: "Handover Area" },
  { value: "verification_problem", label: "Verification / Problem Area" },
  { value: "other", label: "Other" },
];

export const priorityMeta = (p) => PRIORITY_META[p] || PRIORITY_META.normal;
export const statusMeta = (s) => STATUS_META[s] || { label: s, cls: "text-slate-500 border-slate-200" };
export const reasonLabel = (list, v) => (list.find((x) => x.value === v)?.label) || v;

export const fmtDuration = (sec) => {
  const s = Math.round(sec || 0);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m`;
  return `${s}s`;
};

export const fmtQty = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString());
